import { useThemeColors } from '@/contexts/ThemeContext'
import { theme } from '@/lib/theme'
import type { SlashCommand } from '@/types/chat/SlashCommand'

interface CommandDropdownProps {
  commands: SlashCommand[]
  selectedIndex: number
  onSelect: (index: number) => void
  onMouseEnter: (index: number) => void
}

export default function CommandDropdown({
  commands,
  selectedIndex,
  onSelect,
  onMouseEnter,
}: CommandDropdownProps) {
  const colors = useThemeColors()
  if (commands.length === 0) {
    return null
  }

  return (
    <div
      data-slash-dropdown
      style={{
        position: 'absolute',
        bottom: '100%',
        left: 0,
        right: 0,
        backgroundColor: colors.secondaryBg,
        border: `1px solid ${colors.primaryBorder}`,
        borderRadius: theme.borderRadius.md,
        marginBottom: theme.spacing.sm,
        maxHeight: '300px',
        overflowY: 'auto',
        boxShadow: '0 -4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
      }}
    >
      {commands.map((command, index) => (
        <div
          key={command.id}
          onClick={() => onSelect(index)}
          onMouseEnter={() => onMouseEnter(index)}
          style={{
            padding: `${theme.spacing.sm} ${theme.spacing.md}`,
            cursor: 'pointer',
            backgroundColor:
              index === selectedIndex ? colors.primaryAccent : 'transparent',
            borderBottom:
              index < commands.length - 1
                ? `1px solid ${colors.primaryBorder}`
                : 'none',
            transition: 'background-color 0.15s ease',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing.sm,
            }}
          >
            <span
              style={{
                color: colors.primaryText,
                fontFamily: theme.fontFamily.mono,
                fontWeight: 'bold',
                fontSize: theme.fontSize.md,
              }}
            >
              /{command.name}
            </span>
            <span
              style={{
                color: colors.secondaryText,
                fontFamily: theme.fontFamily.mono,
                fontSize: theme.fontSize.sm,
                flex: 1,
              }}
            >
              {command.description}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}
